var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOpenSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8921 2.92896C17.8921 2.51474 17.5563 2.17896 17.1421 2.17896H10.3921C9.97788 2.17896 9.64209 2.51474 9.64209 2.92896C9.64209 3.34317 9.97788 3.67896 10.3921 3.67896H16.3921V9.67895C16.3921 10.0932 16.7279 10.429 17.1421 10.429C17.5563 10.429 17.8921 10.0932 17.8921 9.67895V2.92896ZM12.3691 8.76259L17.6724 3.45929L16.6118 2.39863L11.3085 7.70193L12.3691 8.76259Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 17.071C2.25 17.4853 2.58579 17.821 3 17.821H9.75C10.1642 17.821 10.5 17.4853 10.5 17.071C10.5 16.6568 10.1642 16.321 9.75 16.321H3.75V10.321C3.75 9.90683 3.41421 9.57105 3 9.57105C2.58579 9.57105 2.25 9.90683 2.25 10.321V17.071ZM7.77297 11.2374L2.46967 16.5407L3.53033 17.6014L8.83363 12.2981L7.77297 11.2374Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOpenSmall);
export default __webpack_public_path__ + "static/media/arrow-open-small.0b5364de481eba5c8c7e259081d18b3b.svg";
export { ForwardRef as ReactComponent };